<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <p>{{message}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="onDismiss()">No</button>
  <button mat-stroked-button cdkFocusInitial (click)="onConfirm()">Yes</button>
</mat-dialog-actions>

